var lib_core           = require("lib-core");
var cio_ui_templates   = require("ui-templates");

var SplitView     = require("./splitView.js");
var TabController = require("./../tab/tabController.js");

var SplitController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};

lib_core.inherit(SplitController, lib_core.Controller);
SplitController.inject = {
    tabController : TabController
};

SplitController.prototype.createView = function () {
    var parentView = this.tabController.getView().getTemplate();
    return new SplitView(parentView, this.configuration.width, this.configuration);
};

module.exports = SplitController;

